import styled from "styled-components";

import { ThemeProp } from "styles/theme";
import { datasetsMenuFonts } from "styles/font-sizes";

export const StyledWrapper = styled.div<{ $visible?: boolean }>`
  box-shadow: 16px 22px 76px -1px ${({ theme }: ThemeProp) => theme.emptyBackground};
  background: ${({ theme }: ThemeProp) => theme.emptyBackground};

  position: relative;
  padding: 5px 0;
  height: 90%;
  width: 100%;

  border: 1px solid #dcdcdc;
  border-left: none;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;

  z-index: 5;

  *,
  & {
    ::-webkit-scrollbar {
      display: none;
    }
  }

  ::before,
  ::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 30px;
  }

  ::after {
    bottom: 0;
    border-bottom-right-radius: 10px;
    background: linear-gradient(
      180deg,
      transparent,
      ${({ theme }: ThemeProp) => theme.emptyBackground}
    );
  }

  ::before {
    top: 0;
    z-index: 1;
    border-top-right-radius: 10px;
    background: linear-gradient(
      0deg,
      transparent,
      ${({ theme }: ThemeProp) => theme.emptyBackground}
    );
  }
`;

export const StyledTitle = styled.div`
  background: ${({ theme }: ThemeProp) => theme.emptyBackground};

  top: 0;
  left: 10%;
  position: absolute;
  transform: translateY(-50%);

  font-size: ${datasetsMenuFonts.menuTitle}px;
  padding: 0 10px;

  border-radius: 25px;
  z-index: 2;
`;
